export class MemberBankDetailsModel {
    bankId: string;
    accountHolderName: string;
    accountNumber: string
    bankName: string;
    countryId: string;
    countryName: string;
    currency: string;
    branchName: string;
    swiftCode: string;
    iban: string;
    routingNo: string;
    type: string;
    companyId: string;
    companyName: string;
    currencyId:string;

    constructor() {
        this.companyId="";
        this.companyName="";
        this.bankId = "";
        this.accountHolderName = "";
        this.accountNumber= "";
        this.bankName = "";
        this.countryId = "";
        this.countryName = "";
        this.currency = "";
        this.branchName = "";
        this.swiftCode = "";
        this.iban = "";
        this.routingNo = "";
        this.type = "";
        this.currencyId="";
    }
}